import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=03b7a99d&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=03b7a99d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b7a99d",
  null
  
)

export default component.exports